export default {
  // 첫번째 인자는 state
  SET_TEST_PLAN: function(state, testPlan) {
    state.testPlan = testPlan;
  },

};
